import { ENV_NAME } from "../redux/constants/metaData";
import { getDefaultNumber } from "../functions/helperMethod";

const _onedrivedata = "onedrivedata";
const _ifsdata = "ifsdata";

export default class CustomerConfig {
  constructor() {
    this.logout = this.setCustomerConfig.bind(this);
    this.isAuthenticated = this.getServiceApi.bind(this);
    this.isTokenVerifycationNeed = this.getAppInsightKey.bind(this);
    this.isIfsCloudVersion = this.IsIfsCloudVersion.bind(this);
  }

  setCustomerConfig(config) {
    if (config) {
      // localStorage.setItem("serviceApi", config.serviceApi);
      localStorage.setItem("appInsightKey", config.appInsightsKey);
      localStorage.setItem("subscriptionKey", config.keyPrimary);
      //localStorage.setItem("userEmail", config.userEmail);
      localStorage.setItem("applicationIDURI", config.applicationIDURI);
      localStorage.setItem("isOneDriveEnable", config.isOneDriveEnable);
      localStorage.setItem("environment", config.environment);
      localStorage.setItem(
        "dataLimit",
        config.dataConfiguration ? config.dataConfiguration.dataLimit : 150
      );
      localStorage.setItem(
        "pageLimit",
        config.dataConfiguration ? config.dataConfiguration.pageLimit : 20
      );
      localStorage.setItem("ifsTokenEndPoint", config.ifsTokenEndPoint);
      localStorage.setItem("ifsClientId", config.ifsClientId);
      localStorage.setItem("ifsRedirecturi", config.ifsRedirecturi);
      localStorage.setItem("isOneDriveDocDeleteEnable", config.isOneDriveDocDeleteEnable);
      return true;
    } else {
      console.log("Invalid customer configurations");
      return false;
    }
  }

  getConfigurationApi() {
    // Config endpoint (api/get-customerconfig) is now served by the main Service API.
    return process.env.REACT_APP_SERVICE_API_URL;
  }

  getEndpoint() {
    return localStorage.getItem("ifsEndpoint");
  }

  getAppInsightKey() {
    return localStorage.getItem("appInsightKey");
  }

  IsIfsCloudVersion() {
    let isIfsCloudVersion = localStorage.getItem("isIfsCloudVersion");
    return isIfsCloudVersion === "true";
  }

  getAppTitle() {
    return localStorage.getItem("appTitle");
  }

  IsContenSearchEnable() {
    let isContenSearchEnable = localStorage.getItem("isContenSearchEnable");
    return isContenSearchEnable === "true";
  }

  IsOneDriveEnable() {
    let isOneDriveEnable = localStorage.getItem("isOneDriveEnable");
    return isOneDriveEnable === "false" ? false : true;
  }

  getSubscriptionKey() {
    return localStorage.getItem("subscriptionKey");
  }

  getDataLimit(dataSourceType = _ifsdata) {
    let dataLimit = getDefaultNumber(localStorage.getItem("dataLimit"), 150);
    let pageLimit = getDefaultNumber(localStorage.getItem("pageLimit"), 20);

    if (dataSourceType === _onedrivedata) {
      return Number(dataLimit) > pageLimit ? Number(dataLimit) : 0;
    };
    return Number(dataLimit) > pageLimit ? Number(dataLimit) - pageLimit : 0;
  }

  get_IfsDataString() {
    return _ifsdata;
  }

  get_OneDriveDataString() {
    return _onedrivedata;
  }

  getPageLimit() {
    return getDefaultNumber(localStorage.getItem("pageLimit"), 20);
  }

  getServiceApi() {
    return process.env.REACT_APP_SERVICE_API_APIM_URL || process.env.REACT_APP_SERVICE_API_URL;
  }

  setOneDriveETag(eTag) {
    localStorage.setItem("eTag", eTag);
  }

  getOneDriveETag() {
    return localStorage.getItem("eTag") || "";
  }

  setIFSETag(eTag) {
    localStorage.setItem("ifsETag", eTag);
  }

  getIFSETag() {
    return localStorage.getItem("ifsETag") || "";
  }

  setCachedETag(eTagType, eTag) {
    localStorage.setItem(eTagType, eTag);
  }

  getCachedETag(eTagType) {
    return localStorage.getItem(eTagType) || "";
  }

  getIfsTokenEndPoint() {
    return localStorage.getItem("ifsTokenEndPoint");
  }

  getIfsClientId() {
    return localStorage.getItem("ifsClientId");
  }

  getIfsRedirecturi() {
    return localStorage.getItem("ifsRedirecturi");
  }

  getIsOneDriveDocDeleteEnable() {
    let result = String(localStorage.getItem("isOneDriveDocDeleteEnable"))?.toLowerCase?.() === 'true'
    return result;
  }
}
